/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import React, { useEffect, useRef, useState } from 'react';
import { motion } from "framer-motion";
import { useNavigate } from 'react-router-dom';
import FilterModal from '../Filter';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import AnimatedButton from '../../../../components/Animation/AnimatedButton';
import { useOnClickOutside } from '../../../../CommonMethods/OutsideClick';
import { Link } from 'react-router-dom';
import ManageProviderExportFn from '../Export';
import GlobalContext from '../../../../components/Context/GloablContext';
import { useContext } from 'react';
import HelpGuideModal from '../../../../components/HelpGuideModal';
import {useGetHelpGuideAdminQuery} from '../../../../features/patientSlice'
import { handleSidebarPrvState } from '../../../../redux/systemConfigSlice';

const ManageProviderTopBar = ({
    title,
    path,
    pathPlaceholder,
    SearchInput,
    AddButton,
    menuBar,
    handleApplyFilter,
    buttonName,
    ApplyFilter,
    suggestions,
    setSuggestions,
    optimizedFn,
    setFilterValues,
    filterValues,
    initialState,
    SearchPlaceholder,
    isColumnSelect,
    setIsColumnSelect,
    exportCols,
    username,
    searchProvider,
    handleCheckboxChange,
    setConfirmationState, data, exportUsers, isIdexport }) => {

    const navigate = useNavigate()
    const {setToastErrorMessage,toastErrorMessage,setToastMessage,isSideBar,setIsSideBar,isAdvancedSearchOpen,setIsAdvancedSearchOpen}  =useContext(GlobalContext)
    const fileInputRef = useRef(null);
    const [searchParams, setSearchParams] = useSearchParams()
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const [isChangeStatusOPen, setIsChangeStatusOpen] = useState(false)
    const dispatch = useDispatch()

    const [isHover, setIsHover] = useState(false)
    const outSideClick = useRef();
    const selectedRows = useSelector(state => state?.MultiSelectSlice?.selectedRows?.selectedIds)
    const filtervals = useSelector(state => state?.systemConfigData?.filterState)
    const ref = useRef()
    const [helpGuideModel, setHelpGuideModel] = useState(false);
    const [triggerApiCall, setTriggerApiCall] = useState(false);
    const [queryParamsadmin, setQueryParamsadmin] = useState('')
    const userType=localStorage?.getItem('user_type')!==null?localStorage.getItem('user_type'):sessionStorage.getItem('user_type')
      
    const { data: helpguidedata, status: helpguidestatus } = useGetHelpGuideAdminQuery(queryParamsadmin, {
        skip: !triggerApiCall,  // Skip the query until the trigger is set to true
    });
    
    
    
    useEffect(() => {
        if (userType === 'corporate-user') {
            setQueryParamsadmin('type=corporate-list-providers');
        } else {
            setQueryParamsadmin('type=admin-list-providers');
        }
    }, [userType]);
      
    useEffect(() => {
        if (queryParamsadmin) {
            setTriggerApiCall(true);  // Allow the query to run
        }
    }, [queryParamsadmin]);
    useOnClickOutside(outSideClick, () => {
        setIsFilterOpen(false)
    })
    useOnClickOutside(ref, () => {
        setIsChangeStatusOpen(false)
    })

    const handleOpenFilter = () => {
        if ((searchParams.get("status") !== null || searchParams.get("provider_credential") !== null ) && !isFilterOpen) {
            setFilterValues(filtervals)
        }
        else if (searchParams.get("field") === null && searchParams.get("action") === null && searchParams.get("permission_access") === null) {
            setFilterValues({
                "status": '',
                "provider_credential": '',
            })
        }
        setIsFilterOpen(!isFilterOpen)
    }

    // Function to handle onClick logic
    const handleSearchClick = () => {  
        // Store the current isSideBar state in Redux
        dispatch(handleSidebarPrvState(isSideBar));
      
        // Update the states after storing the previous state
        setIsAdvancedSearchOpen(true);
        setIsSideBar(false);
    };

    function handleActivateClick(status) {
        if (selectedRows.map((item) => item.name).length > 50) {
            setToastErrorMessage(`You cannot ${status} more than 50 users at once`)
            setIsChangeStatusOpen(false)
            return
        }
        setIsChangeStatusOpen(false)
        if (status === "activate") {
            setConfirmationState((prev) => ({ ...prev, isOpen: selectedRows.map((item) => item.name).length > 50 ? false : true, multirow: 'active', rowData: "", user_names: selectedRows.map((item) => item.name) }))
        }
        else {
            setConfirmationState((prev) => ({ ...prev, isOpen: selectedRows.map((item) => item.name).length > 50 ? false : true, multirow: 'deactive', rowData: "", user_names: selectedRows.map((item) => item.name) }))
        }
    }


    return (
        <div className="flex justify-between items-center mb-[14px]">
            <div className='flex items-center'>
                {title !== undefined ?
                    <h1 className="text-xl font-normal text-[#000000] self-center min-w-max">{title}</h1>
                    :
                    pathPlaceholder &&
                    <Link to={path} state={username && path !== '/manage-admin-corporate/' ? [username] : null} className='hidden items-center min-w-max xl:flex'>
                        <span><img src="/images/back_button_Green.svg" alt="icon" /></span>
                        <span className='text-sm font-normal text-[#008586] ml-3'>{pathPlaceholder}</span>
                    </Link>
                }
                {
                    userType !=='super-admin' &&
                    <span   onClick={() => setHelpGuideModel(true)} className='ml-2 cursor-pointer min-w-max'>
                        <img src="/images/helpguideicon.png" alt="icon" loading="lazy" decoding="async" />
                    </span> 
                }

            </div>
       
            <div className="flex items-center w-fit justify-end relative 2xl:flex-nowrap flex-wrap">
                {menuBar && <div className='relative'>
                    <button id="threedot" className={`rounded-[15px] border border-[#972E4C] px-[13px] py-[10px] mr-2.5 2xl:mb-0 mb-2.5 hover:bg-[#972E4C] focus:bg-[#972E4C] ${isChangeStatusOPen ? 'bg-[#972E4C]' : 'bg[#1111]'}`}
                        onClick={() => { setIsChangeStatusOpen(!isChangeStatusOPen),setIsFilterOpen!==undefined&&setIsFilterOpen(false) }}
                        onMouseEnter={() => setIsHover(true)}
                        onMouseLeave={() => setIsHover(false)}
                    >
                        {
                            isHover || isChangeStatusOPen ? <img src="/images/3dots_white.svg" alt="img" /> : <img src="/images/3_dots_color.svg" alt="img" />

                        }
                    </button>
                    {isChangeStatusOPen && <ul ref={ref} className='px-1.5 py-3 rounded-[6px] absolute top-12 lg:left-[-10px] right-5 bg-[#fff] min-w-[202px] shadow-s3 z-[2] '>
                        <li className='pl-3 pr-[9px] py-1 text-base font-bold text-[#972E4C] mb-2'>Change Status</li>
                        <li>
                            <ul>
                                <li>
                                    <AnimatedButton
                                        handleClick={(e) => { handleActivateClick("activate") }}
                                        buttonName={"Activate"}
                                        disabled={(selectedRows?.filter((user) => user.status === 'inactive'))?.map((item) => item.name).length === 0 ? true : false}
                                        className={`pl-3 pr-[9px] py-1 mb-2 text-base font-normal ${(selectedRows?.filter((user) => user.status === 'inactive'))?.map((item) => item.name).length === 0 ? 'text-[#6e6d6d]' : 'hover:text-[#008586] text-[#000000] cursor-pointer'} `} />
                                </li>
                                <li>
                                    <AnimatedButton
                                        handleClick={(e) => { handleActivateClick("deactivate") }}
                                        buttonName={"Deactivate"}
                                        disabled={(selectedRows?.filter((user) => user.status === 'active'))?.map((item) => item.name).length === 0 ? true : false}
                                        className={`pl-3 pr-[9px] py-1 mb-2 text-base font-normal ${(selectedRows?.filter((user) => user.status === 'active'))?.map((item) => item.name).length === 0 ? 'text-[#706a6a]' : 'hover:text-[#008586] text-[#000000] cursor-pointer'}  `} />
                                </li>
                            </ul>
                        </li>
                    </ul>}
                </div>}
                {SearchInput && searchProvider && <button id='search-btn' onClick={handleSearchClick} className="ml-2.5 2xl:mb-0 mb-2.5 border border-[#972E4C] rounded-[15px] px-[13px] py-[13px]">
                    <img loading='lazy' decoding='async' src="/images/search_red.svg" alt="icon" className=''/>
                </button>}
                {SearchInput && !searchProvider &&  <div className="relative ml-2.5 2xl:mb-0 mb-2.5">
                    <label htmlFor="input"></label>
                    <input
                        maxLength={90}
                        type="text"
                        id="search-value"
                        autoComplete='off'
                        value={suggestions}
                        autoFocus={suggestions !== ''}
                        onChange={(e) => { setSuggestions(e.target.value); optimizedFn(e.target.value) }}
                        className="pl-10 pr-[31px] w-[222px] py-2.5 border border-[#972E4C] rounded-[16px] placeholder:text-xs placeholder:font-normal placeholder:text-[#52555D] text-base font-normal text-[#000B17] outline-0" placeholder={SearchPlaceholder} />
                    <img src="/images/search_red.svg" alt="icon" className="absolute top-1/2 -translate-y-1/2 left-3" />
                    <button onClick={() => { setSuggestions(""); optimizedFn("") }}>
                        {suggestions !== "" && <img src="/images/clear_search.svg" alt="icon" className="absolute top-1/2 -translate-y-1/2 right-2.5" />}
                    </button>


                    {/* <!-- <button className="absolute top-[50%] -translate-y-[50%] right-3.5 inline-block">
                            <img loading="lazy" decoding="async" src="images/search.svg" alt="img"/>
                        </button> --> */}

                </div>}
                {(ApplyFilter !== undefined && ApplyFilter) &&
                    <FilterModal
                        isFilterOpen={isFilterOpen}
                        setIsFilterOpen={setIsFilterOpen}
                        handleApplyFilter={handleApplyFilter}
                        filterValues={filterValues}
                        setFilterValues={setFilterValues}
                        initialState={initialState}
                        handleOpenFilter={handleOpenFilter} 
                        handleCheckboxChange={handleCheckboxChange}
                    />
                }
                {SearchInput && data !== undefined && data?.data?.length > 0 && <div>  
                    <ManageProviderExportFn
                        selectedRows={selectedRows}
                        exportUsers={exportUsers}
                        exportCols={exportCols}
                        setIsFilterOpen={setIsFilterOpen}
                        isColumnSelect={isColumnSelect}
                        setIsColumnSelect={setIsColumnSelect}
                        isIdexport={isIdexport} username={username} />
                </div>}
                {AddButton &&
                    <>{<Link to={path} state={{...Object.fromEntries(searchParams)}}>
                        <button type='button'
                            id="Add user"
                            className={`py-2.5 px-4   flex items-center text-lg font-normal text-[#fff] rounded-[16px] ml-2.5 2xl:mb-0 mb-2.5
                                bg-[#972E4C] hover:bg-[#AB556E] focus:bg-[#863B50] disabled:bg-[#777C88]`}>
                            <span className="mr-2.5"><img src="/images/add_Icon_white.svg" alt="img" /></span>
                            {buttonName}
                        </button>
                    </Link>}</>}
                {(helpGuideModel && helpguidestatus==="fulfilled") &&
                    <HelpGuideModal
                        setHelpGuideModel={setHelpGuideModel}
                        pdfUrl={helpguidedata} // Pass the PDF URL to the modal
                    />
                }
            </div>
        </div>
    );
}

export default ManageProviderTopBar;
